import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './TabsWithAccordion.css';
import React, { useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { MAX_MOBILE_WIDTH } from '../../utils/constants';
import { ReactComponent as ChevronRight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import { ReactComponent as IconChevronDown } from "../../resources/icons/IconChevronDown.svg";
import Spoiler from '../atoms/Spoiler/Spoiler';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { canUseDOM, get } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
var BASE_URL = process.env.REACT_APP_MEDIA_HOST ? process.env.REACT_APP_MEDIA_HOST : '';
var TabsWithAccordion = function TabsWithAccordion(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var title = get(fields, "data.item.title.jss", {
    value: ""
  });
  var subtitle = get(fields, "data.item.subtitle.jss", {
    value: ""
  });
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    allTabsIsClosed = _useState4[0],
    setAllTabIsClosed = _useState4[1];
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var filterAccordionItems = function filterAccordionItems(accordionItems) {
    return accordionItems.filter(function (el) {
      return el.title.jss.value && el.description.jss.value;
    });
  };
  var tabs = get(fields, "data.item.tabs", []).filter(function (el) {
    return el.title.jss.value && (el.description.jss.value || el.accordionItems && filterAccordionItems(el.accordionItems).length > 1);
  });
  var onTabClick = function onTabClick(step) {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["tabClick"], params), tabs[step].title.jss.value);
    if (canUseDOM && window.innerWidth <= Number.parseInt(MAX_MOBILE_WIDTH) && !allTabsIsClosed && step === selectedTab) {
      setAllTabIsClosed(true);
    } else {
      setAllTabIsClosed(false);
    }
    setSelectedTab(step);
  };
  var renderAccordion = function renderAccordion(tab) {
    var items = tab.accordionItems && filterAccordionItems(tab.accordionItems);
    return /*#__PURE__*/React.createElement(React.Fragment, null, items && items.length > 1 && /*#__PURE__*/React.createElement("div", {
      className: "accordion__spoilers-wrapper"
    }, items.map(function (el, i) {
      return /*#__PURE__*/React.createElement(Spoiler, {
        onToggle: function onToggle(val) {
          return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["accordionAction"], params), [tabs[selectedTab].title.jss.value, el.title.jss.value, val ? "expand" : "collapse"]);
        },
        key: i,
        title: el.title.jss.value
      }, /*#__PURE__*/React.createElement(RichText, {
        tag: "p",
        field: el.description.jss
      }), el.ctaLink.jss.value.href && /*#__PURE__*/React.createElement("a", {
        className: "accordion__cta",
        href: el.ctaLink.jss.value.href,
        target: el.ctaLink.jss.value.target,
        onClick: function onClick() {
          return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["accordionAction"], params), [tabs[selectedTab].title.jss.value, el.title.jss.value, el.ctaLabel.jss.value]);
        }
      }, el.ctaLabel.jss.value, rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
        className: "btn-link__icon"
      }) : /*#__PURE__*/React.createElement(ChevronRight, {
        className: "btn-link__icon"
      })));
    })));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isGrey: params["Is Grey"] ? params["Is Grey"] === "1" : false,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 accordion__main-title",
    field: title,
    "data-cy": "accordion-title"
  }), /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "accordion__main-description accordion__description",
    field: subtitle,
    "data-cy": "accordion-description"
  }), /*#__PURE__*/React.createElement("div", {
    className: "accordion ".concat(allTabsIsClosed ? "accordion--tabs-hidden-on-mobile" : ""),
    style: {
      gridTemplateRows: "repeat(".concat(tabs.length, ", minmax(6.25rem, auto)) auto")
    }
  }, tabs.length > 1 && tabs.map(function (tab, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, /*#__PURE__*/React.createElement("button", {
      className: "accordion__tab ".concat(i === selectedTab ? "accordion__tab--selected-tab" : ""),
      onClick: function onClick() {
        return onTabClick(i);
      },
      tabIndex: 0
    }, /*#__PURE__*/React.createElement("div", {
      className: "accordion__tab-title-content"
    }, /*#__PURE__*/React.createElement(Text, {
      field: tab.title.jss
    }), /*#__PURE__*/React.createElement(IconChevronDown, {
      className: "accordion__chevron"
    }))), i === selectedTab && /*#__PURE__*/React.createElement("div", {
      className: "accordion__content ".concat(tab.image && tab.image.jss.value.src ? "accordion__content--with-image" : "accordion__content--without-image"),
      style: {
        gridRowEnd: tabs.length + 2
      }
    }, tab.image && tab.image.jss.value.src && /*#__PURE__*/React.createElement("img", {
      className: "accordion__image",
      src: BASE_URL ? "".concat(BASE_URL).concat(tab.image.jss.value.src, "&cw=600&ch=500") : tab.image.jss.value.src,
      alt: tab.image.jss.value.alt
    }), /*#__PURE__*/React.createElement("div", {
      className: "accordion__text-content"
    }, tab.title.jss.value && /*#__PURE__*/React.createElement("h1", {
      className: "accordion__title"
    }, tab.title.jss.value), /*#__PURE__*/React.createElement(RichText, {
      className: "accordion__description",
      tag: "p",
      field: {
        value: tab.description.jss.value
      }
    }), tab.ctaLink && tab.ctaLink.jss.value.href && /*#__PURE__*/React.createElement("a", {
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["ctaClick"], params), [tabs[selectedTab].title.jss.value, tab.ctaLabel ? tab.ctaLabel.jss.value : ""]);
      },
      className: "accordion__cta",
      href: tab.ctaLink.jss.value.href,
      target: tab.ctaLink.jss.value.target,
      title: tab.ctaLink.jss.value.title
    }, tab.ctaLabel && tab.ctaLabel.jss.value, rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
      className: "btn-link__icon"
    }) : /*#__PURE__*/React.createElement(ChevronRight, {
      className: "btn-link__icon"
    })), renderAccordion(tab))));
  }))));
};
export default TabsWithAccordion;
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    isGrey = _ref2.isGrey,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(commonStyles, " ").concat(isGrey ? "".concat(commonStyles, "--grey") : "", " ").concat(rtl ? rtlStyles : ltrStyles),
    anchorUrlParameter: anchorUrlParameter
  }, children);
};
var commonStyles = "croovjs";
var rtlStyles = "r18x6moe";
var ltrStyles = "ly4v9v9";